import React from 'react'
import styled from 'styled-components'
import { FilteredPropertyData } from '../../../types/PropertyData'
import { OptionButton } from './OptionButton'

export type OptionsCircleProps = {
  propertyData: FilteredPropertyData
  value?: string
  setValue?: (nextValue: string) => void
  className?: string
}

const CircleButtonImage = styled.div<{ $src?: string }>`
  width: 100px;
  height: 100px;
  background-color: hsla(0, 0%, 68.6%, 0.1);
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('${({ $src }) => $src}');
`

const CircleButton = styled(OptionButton)`
  border-radius: 100%;
  width: 100px;
  height: 100px;

  &::after {
    border-radius: 100%;
  }
`

const CircleButtonWrap = styled.div`
  ${CircleButton} {
    margin: 10px;
  }

  h4 {
    text-align: center;
    width: 100px;
    margin: 5px 10px 0;
    padding: 0 5px;
  }
`

const OptionsCircle = styled<React.FC<OptionsCircleProps>>(
  ({ className, propertyData: { values }, value, setValue }) => {
    return (
      <div className={className}>
        {values
          .filter((x) => !x.disabled || x.disabled.type !== 'hidden')
          .map(({ id, displayName, thumbnail, disabled }) => (
            <CircleButtonWrap key={id}>
              <CircleButton $active={value === id} $disabled={!!disabled} onClick={() => setValue?.(id)}>
                <CircleButtonImage $src={thumbnail?.url} />
              </CircleButton>
              <h4>{displayName}</h4>
            </CircleButtonWrap>
          ))}
      </div>
    )
  }
)`
  margin: 10px -10px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export default OptionsCircle
